import { useCallback } from 'react';
import isNil from 'lodash/isNil';
import {
    ExtendVenueFlags,
    FormSection,
    RequestResultsStatus,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { EAskFowReviewFormSectionType } from './types';
import { ReasonForNearBy } from './steps/reason-for-nearby';
import { UpdatePropertyName } from './steps/update-property-name';
import { UpdatePropertyAddress } from './steps/update-property-address';
import { NotFoundOtherProperty } from './steps/not-my-property';
import { getFeatureFlags } from 'core/flow-control';

type AskFowReviewGetFormConfigProps = {
    status: RequestResultsStatus;
    entityId: string | undefined;
    flag: ExtendVenueFlags | undefined;
};

export const useAskFowReviewFormSchema = () => {
    const {
        enable_support_request_reason_for_nearby,
        enable_support_request_not_my_property,
        enable_support_request_update_entity_name,
        enable_support_request_update_entity_address,
    } = getFeatureFlags();

    const getFormsConfig = useCallback(
        ({ status, entityId, flag }: AskFowReviewGetFormConfigProps) => {
            return [
                ...(!isNil(entityId) && enable_support_request_not_my_property
                    ? ([
                          {
                              title: 'Looking for a different property',
                              testId: 'not-my-property',
                              type: EAskFowReviewFormSectionType.NotMyProperty,
                              Form: NotFoundOtherProperty,
                          },
                      ] as FormSection<EAskFowReviewFormSectionType>[])
                    : []),
                ...(enable_support_request_reason_for_nearby && flag
                    ? ([
                          {
                              title: 'Reason for nearby activity report',
                              testId: 'reason-for-nearby',
                              type: EAskFowReviewFormSectionType.ReasonForNearby,
                              Form: ReasonForNearBy,
                          },
                      ] as FormSection<EAskFowReviewFormSectionType>[])
                    : []),
                ...(status === 'Available' && enable_support_request_update_entity_name
                    ? ([
                          {
                              title: 'Update the property’s name',
                              testId: 'update-property-name',
                              type: EAskFowReviewFormSectionType.UpdatePropertyName,
                              Form: UpdatePropertyName,
                          },
                      ] as FormSection<EAskFowReviewFormSectionType>[])
                    : []),
                ...(status === 'Available' && enable_support_request_update_entity_address
                    ? ([
                          {
                              title: 'Update the property’s address',
                              testId: 'update-property-address',
                              type: EAskFowReviewFormSectionType.UpdatePropertyAddress,
                              Form: UpdatePropertyAddress,
                          },
                      ] as FormSection<EAskFowReviewFormSectionType>[])
                    : []),
            ] as FormSection<EAskFowReviewFormSectionType>[];
        },
        [
            enable_support_request_reason_for_nearby,
            enable_support_request_not_my_property,
            enable_support_request_update_entity_address,
            enable_support_request_update_entity_name,
        ],
    );

    return { getFormsConfig };
};
